import { UserRole } from "@myapp/contract";

type RoleKey = Exclude<UserRole, null>;

const roleMap: Record<RoleKey, string> = {
  WORKER: "Handwerker",
  MANAGER: "Büroangestellter",
  DIRECTOR: "Leiter",
  SUPERUSER: "Superadmin",
};

export const getPositionFromRole = (role?: UserRole): string => {
  if (!role) return "Unbekannte Rolle";
  return roleMap[role as RoleKey] ?? "Unbekannte Rolle";
};

export const getPositionsFromRoles = (roles?: UserRole[]): string => {
  if (!roles || roles.length === 0) return "Unbekannte Rolle";
  return roles.map((r) => roleMap[r as RoleKey] ?? "Unbekannte Rolle").join(", ");
};